<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/welcome' }">主页</el-breadcrumb-item>
            <el-breadcrumb-item>套餐管理</el-breadcrumb-item>
            <el-breadcrumb-item>套餐列表</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>
            <el-row :gutter="24">
                <el-col :span="4">
                    <el-input
                        v-model="queryInfo.name"
                        placeholder="请输入套餐名称"
                        clearable
                    >
                    </el-input>
                </el-col>
                <el-col :span="4">
                    <el-select v-model="queryInfo.sort" placeholder="请选择排序方式">
                        <el-option
                        v-for="item in sortOrder"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="10">
                    <el-button @click="handleSearch" type="primary">搜索</el-button>
                    <el-button @click="handleAdd" type="success">新增</el-button>
                    <el-button @click="handleClear" type="warning">清空</el-button>
                </el-col>
            </el-row>
            <el-table :data="dataList" stripe>
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column label="套餐名称" prop="name" width="210"></el-table-column>
          <el-table-column label="套餐类别"  prop="type" width="95">
            <template slot-scope="scope">
              {{scope.row.type==1?'限次':scope.row.type==4?'限小时':''}}
            </template>
          </el-table-column>
          <el-table-column label="套餐场景"  prop="classType" width="95">
            <template slot-scope="scope">
              {{scope.row.classType==0?'通用':scope.row.classType==1?'一对一':'班课'}}
            </template>
          </el-table-column>
          <el-table-column label="次数"  prop="times" width="90">
            <template slot-scope="scope">
              {{scope.row.times != null?scope.row.times:'—'}}
            </template>
          </el-table-column>
          <el-table-column label="赠送次数"  prop="giveTimes" width="100">
            <template slot-scope="scope">
              {{scope.row.giveTimes != null?scope.row.giveTimes:'—'}}
            </template>
          </el-table-column>
          <el-table-column label="时长（小时）"  prop="hours" width="110">
            <template slot-scope="scope">
              {{scope.row.hours != null?scope.row.hours:'—'}}
            </template>
          </el-table-column>
          <el-table-column label="赠送时长（小时）"  prop="giveHours" width="140">
            <template slot-scope="scope">
              {{scope.row.giveHours != null?scope.row.giveHours:'—'}}
            </template>
          </el-table-column>
          <el-table-column label="套餐价格"  prop="price" width="110">
            <template slot-scope="scope">
              ￥{{scope.row.price}}
            </template>
          </el-table-column>
              <el-table-column label="套餐状态" width="115" prop="openStatus">
                <template slot-scope="scope">
                  <div class="slide-switch" @click="handleSwitch(scope.$index, scope.row)">
                    <div
                      class="slider"
                      :class="{ active: scope.row.openStatus === 1 }"
                      :style="{ backgroundColor: scope.row.openStatus === 1 ? '#52c41a' : '#ff4d4f' }"
                    >
                        <span class="slider-text">
                          {{ scope.row.openStatus === 1 ? 'ON' : 'OFF' }}
                        </span>
                      <div class="slider-button"></div>
                    </div>
                  </div>
                </template>
              </el-table-column>
          <el-table-column label="操作" width="110">
            <template slot-scope="scope">
              <el-button @click="handleEdit(scope.row)" type="text" style="color:#FF9F00">编辑</el-button>
              <el-button @click="handleDelete(scope.row)" type="text" style="color:#F53F3F">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="queryInfo.pageNo"
                :page-sizes="[10, 15, 20, 25, 30, 35]"
                :page-size="queryInfo.pageSize"
                :total="total"
                background
            ></el-pagination>
        </el-card>
    </div>
</template>
<script>
    export default {
        data() {
            return{
                dataList: [],
                sortOrder: [
                    { id:1, name:'价格升序' },
                    { id:2, name:'价格降序' },
                    { id:3, name:'次数升序' },
                    { id:4, name:'次数降序' },
                    { id:5, name:'新增时间升序' },
                    { id:6, name:'新增时间降序' }
                ],
                queryInfo: {
                    type: null,
                    sort: null,
                    pageSize: 10,
                    pageNo: 1,
                },
                courseList: [],
                queryInfoModal: {
                    type: null,
                    name: null,
                    pageSize: 10,
                    pageNo: 1,
                },
                modalTotal: 0,
                modalSelectList: [],
                total: 0,
                selectList: []
            }
        },
      created() {
      },
      mounted() {
            this.initData();
        },
        methods:{
            async initData() {
                await this.$http.post("/ea/student/setMeal/list",this.queryInfo).then((res) => {
                    let data = res.data;
                    if(data && data.code == 200 || data.code == 0){
                        this.dataList = data.result.records;
                        this.total = data.result.total;
                    }else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type:'error'
                        });
                    }
                })
            },
            async initCourseData() {
                const { data: res } = await this.$http.post("/ea/student/course/list",this.queryInfoModal);
                    if(res.code == 200){
                        this.courseList = res.result.records;
                        this.modalTotal = res.result.total;
                    }else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type:'error'
                        });
                    }
            },
            handleSearch() {
                this.initData();
            },
            handleSearch2() {
                this.initCourseData();
            },
            handleAdd() {
                 this.$router.push("/createSetMeal");
            },
            handleSelectionChangeModal(val) {
                this.modalSelectList = val;
            },
            // 套装页码切换
            handleCurrentChangeModal(pageNum){
                this.queryInfoModal.pageNo = pageNum;
                this.initCourseData();
            },
            handleSizeChangeModal(val) {
                this.queryInfoModal.pageSize = val;
            },
          async handleSwitch(index, row) {
            if(!row.openStatus){
              row.openStatus = 0
            }
            row.openStatus = 1 - row.openStatus;
            let idModel = {
              id:row.id
            }
            const { data: res } = await this.$http.post(`/ea/student/setMeal/modifyOpenStatus`,idModel);
            if (res.code !== 200){
              this.$message.error(res.message);
              setTimeout(function(){
                row.openStatus = 1 - row.openStatus;
              },200)
            }else{
              this.$message({
                type: 'success',
                message: '切换状态成功'
              });
            }
          },
            handleClear() {
                this.queryInfo.name = '';
                this.queryInfo.sort = null;
                this.queryInfoModal.name = '';
                this.queryInfoModal.type = null;
            },
            handleSelectionChange(val) {
                this.selectList = val;
            },
            // 套装页码切换
            handleCurrentChange(pageNum){
                this.queryInfo.pageNo = pageNum;
                this.initData();
            },
            handleSizeChange(val) {
                this.queryInfo.pageSize = val;
            },
            handleEdit(record) {
                this.$router.push({
                    name: "createSetMeal",
                    params: {recordDate:record,type:'edit'}
                });
            },
            handleDelete(record) {
                this.$confirm('确定删除该套餐吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http.post("/ea/student/setMeal/delete",{id:record.id}).then((res) => {
                        let data = res.data;
                        if(data && data.code == 0 || data.code == 200){
                            this.$message({
                                message: '删除成功',
                                type:'success'
                            });
                            this.initData();
                        }else {
                            this.$message({
                                showClose: true,
                                message: data.message,
                                type:'error'
                            });
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
        }
    }
</script>

<style scoped>
  .slide-switch {
    display: inline-block;
    cursor: pointer;
  }
  .slider {
    position: relative;
    width: 90px;
    height: 30px;
    border-radius: 15px;
    transition: all 0.3s ease;
  }
  .slider-button {
    position: absolute;
    width: 26px;
    height: 26px;
    background: white;
    border-radius: 50%;
    top: 2px;
    left: 2px;
    transition: transform 0.3s ease;
  }
  .active .slider-button {
    transform: translateX(60px); /* 滑动距离 */
  }
  .slider-text {
    position: absolute;
    width: 100%;
    text-align: center;
    line-height: 30px;
    color: white;
    font-weight: bold;
    font-size: 12px;
  }
</style>
